export const getTraceIdAndTimestamp = (message: string) => {
  const r = /TraceId:\s(.+).?\.\sTimestamp:\s(.+)\./;
  const matches = message.match(r);

  return matches ? ` TraceId: ${matches[1]}. Timestamp: ${matches[2]}.` : '';
};
